import PropTypes from 'prop-types'
import React from 'react'
import { CheckCircleIcon } from '../../assets/icons/CheckCircleIcon'
import { TimesCircleIcon } from '../../assets/icons/TimesCircleIcon'
import { TrashIcon } from '../../assets/icons/TrashIcon'
import {
  BUTTON_STYLE_DANGER,
  BUTTON_STYLE_DEFAULT,
  BUTTON_STYLE_PRIMARY,
  BUTTON_STYLE_SECONDARY
} from '../../libraries/ButtonTheme'
import { languageValues } from '../../utils/LanguageUtils'
import Modal from './Modal'

export function AlertModal(props) {
  const getProps = () => {
    const p = {
      footer: [
        {
          children:
            !props.language || !props.language.confirm
              ? languageValues.components.modals.alertModal.confirm
              : props.language.confirm,
          onClick: props.onConfirm,
          theme: 'primary',
          leftIcon: props.showIcons ? <CheckCircleIcon /> : undefined
        }
      ],
      ...props
    }
    delete p.showIcons
    return p
  }
  return <Modal {...getProps()} />
}

AlertModal.propTypes = {
  ...Modal.propTypes,
  language: PropTypes.shape({
    confirm: PropTypes.string
  }),
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  showIcons: PropTypes.bool
}

AlertModal.defaultProps = {
  showIcons: true
}

export function ConfirmModal(props) {
  const getProps = () => {
    const p = {
      footer: [
        {
          children:
            !props.language || !props.language.cancel
              ? languageValues.components.modals.confirmModal.cancel
              : props.language.cancel,
          onClick: props.onCancel,
          theme: BUTTON_STYLE_SECONDARY,
          leftIcon: props.showIcons ? <TimesCircleIcon /> : undefined
        },
        {
          children:
            !props.language || !props.language.confirm
              ? languageValues.components.modals.confirmModal.confirm
              : props.language.confirm,
          onClick: props.onConfirm,
          theme: BUTTON_STYLE_PRIMARY,
          leftIcon: props.showIcons ? <CheckCircleIcon /> : undefined
        }
      ],
      ...props
    }
    delete p.showIcons
    return p
  }
  return <Modal {...getProps()} />
}

ConfirmModal.propTypes = {
  ...Modal.propTypes,
  language: PropTypes.shape({
    confirm: PropTypes.string,
    cancel: PropTypes.string
  }),
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  showIcons: PropTypes.bool
}

ConfirmModal.defaultProps = {
  showIcons: true
}

export function DestructiveModal(props) {
  const getProps = () => {
    const p = {
      footer: [
        {
          children:
            !props.language || !props.language.cancel
              ? languageValues.components.modals.destructiveModal.cancel
              : props.language.cancel,
          onClick: props.onCancel,
          theme: BUTTON_STYLE_DEFAULT,
          leftIcon: props.showIcons ? <TimesCircleIcon /> : undefined
        },
        {
          children:
            !props.language || !props.language.confirm
              ? languageValues.components.modals.destructiveModal.confirm
              : props.language.confirm,
          onClick: props.onConfirm,
          theme: BUTTON_STYLE_DANGER,
          leftIcon: props.showIcons ? <TrashIcon /> : undefined
        }
      ],
      ...props
    }
    delete p.showIcons
    return p
  }
  return <Modal {...getProps()} />
}

DestructiveModal.propTypes = {
  ...Modal.propTypes,
  language: PropTypes.shape({
    confirm: PropTypes.string,
    cancel: PropTypes.string
  }),
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  showIcons: PropTypes.bool
}

DestructiveModal.defaultProps = {
  showIcons: true
}
